import {
    Checkbox,
    FormControl,
    FormControlLabel,
    FormHelperText,
} from "@mui/material";
import {CheckboxLabel} from "./CheckboxInput.styles";
import React from "react";
import clsx from "clsx";

interface CheckboxInputProps {
    className?: string;
    checked: any;
    name: string;
    label?: any;
    radio?: boolean;
    errorMessage?: string;
    value?: string | number | boolean;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    disabled?: boolean;
}

export const commonRadioProps = {
    icon: <img id="circleUnchecked" className="hidden-icon" alt="circleUnchecked" src={"img/circleUnchecked.svg"}/>,
    checkedIcon: <img id="circleChecked" className="hidden-icon" alt="circleChecked" src={"img/circleChecked.svg"}/>
}

export const commonCheckboxProps = {
    icon: <img id="checkboxUnchecked" className="hidden-icon" alt="checkboxUnchecked" src={"img/checkboxUnchecked.svg"}/>,
    checkedIcon: <img id="checkboxChecked" className="hidden-icon" alt="checkboxChecked" src={"img/checkboxChecked.svg"}/>
}

export const CheckboxInput = ({className, label, name, checked, radio, onChange, errorMessage, value, disabled}: CheckboxInputProps) => {
    const commonProps = radio ? commonRadioProps : commonCheckboxProps;

    return (
        <FormControl variant="outlined" error={!!errorMessage}>
            <FormControlLabel
                className={clsx(className, "no-fastclick")}
                control={<Checkbox
                    disabled={disabled}
                    name={name}
                    checked={checked || !!value}
                    onChange={onChange}
                    {...commonProps}
                />}
                label={<CheckboxLabel>{label}</CheckboxLabel>}
            />
            <FormHelperText>{!!errorMessage && errorMessage}</FormHelperText>
        </FormControl>
    );
}